import { Component } from '@angular/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { RouterService } from '../../../services';

@Component({
  selector: 'app-formly-back-button',
  templateUrl: './formly-back-button.component.html',
  styleUrl: './formly-back-button.component.scss',
})
export class FormlyBackButtonComponent extends FormlyFieldBaseComponent {
  constructor(private routerService: RouterService) {
    super();
  }

  onClick() {
    if (this.props.path) {
      this.routerService.path(this.props.path, this.props.route);
    } else {
      this.routerService.back(this.props.route);
    }
  }
}
